module.exports = __webpack_public_path__ + "img/cost-effective.322b136b.png";